/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProSplash.css';
import WhereField from './partials/WhereField';
import LeaderboardWidget from './partials/LeaderboardWidget';
import RegisterForm from './partials/RegisterForm';
import {
  login,
  register,
  fetchUser,
} from '../actions';


class ProSplash extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  state = {};

  componentDidMount() {
    try {
      scroll(0, 0);
    } catch (e) {
    }
  }

  register(e, values) {
    e.preventDefault();
    this.props.register(values)
      .then(resp => {
        if (!resp.error) {
          return this.props.login({
            username: values.username,
            password: values.password,
          });
        }
      })
      .then(resp => {
        if (!resp.error) {
          setToken(resp.token);
          this.props.fetchUser()
            .then(resp => {
              console.log('registered!');
              navTo('/p/' + values.username + '?tehelp=1');
            });
        }
      });
  }

  renderSpreadsheetBlurb() {
    return (
      <div className="spreadsheet-blurb">
        <div className="header">Have a spreadsheet? (BETA)</div>
        <p><b>Do you track your escapes in a spreadsheet?</b> You can import it into EscapeSpy! Use our tool to easily track dozens or hundreds of escapes that you already have in a spreadsheet.</p>
        <Link to="/sh"><Button bsSize="lg">Import Your Spreadsheet</Button></Link>
      </div>
    )
  }

  renderBlurbForm() {
    let user = this.props.user;
    let isLoggedIn = user && user.profile;

    return (
      <div className="blurb-and-form">
        <div className="blurb">
          <div className="blurb-copy">
            <p className="top-line">Get a <b>free&nbsp;leaderboard</b> for your escape room website</p>

            <p>Add a fun leaderboard to your escape room website to highlight the top performing teams, and encourage everyone to do their best.</p>

            <p>EscapeSpy offers the best free escape room leaderboard available on the web.</p>

            <div className="value-prop">
              <div className="value-icon">
                <img src="https://escapespy.s3-us-west-2.amazonaws.com/misc/003-first-place.svg" />
              </div>
              <div className="value-info">
                <div className="value-title">Engage with your customers</div>
                <div className="value-blurb">Highlight top performing teams, and show off photos of the great groups that have played your rooms.</div>
              </div>
            </div>

            <div className="value-prop">
              <div className="value-icon">
                <img src="https://escapespy.s3-us-west-2.amazonaws.com/misc/001-confetti.svg" />
              </div>
              <div className="value-info">
                <div className="value-title">Enhance your website</div>
                <div className="value-blurb">Add a fun widget to your website to make it more engaging for potential customers.</div>
              </div>
            </div>

            <div className="value-prop">
              <div className="value-icon">
                <img src="https://escapespy.s3-us-west-2.amazonaws.com/misc/002-growth.svg" />
              </div>
              <div className="value-info">
                <div className="value-title">Boost your profile</div>
                <div className="value-blurb">Adding escapes to your leaderboard will boost your ranking in the EscapeSpy recommendation engine.</div>
              </div>
            </div>

          </div>
        </div>
        <div className="desktop-form">{this.renderForm()}</div>
      </div>
    );
  }

  renderForm() {
    let user = this.props.user;
    let isLoggedIn = user && user.profile;

    return (
      <div className="form">
        <div className="form-title">
          {/*<div className="form-icon"><img src="https://escapespy.s3-us-west-2.amazonaws.com/misc/awards/006-star.svg" /></div>*/}
          <div className="form-title-copy">
            Sample leaderboard
          </div>
        </div>

        <div className="sample-leaderboard">
            <div style={{'max-width':'300px',width:'100%','margin':'0 auto'}}><LeaderboardWidget size={5} roomId={31737} /><a href="https://www.escapespy.com" style={{'font-size':'11px',color:'#888',opacity:'.8','font-family':'sans-serif'}}>Leaderboard powered by EscapeSpy</a></div>

        </div>

        <div className="go-to-profile">
         <p>Get a free leaderboard from EscapeSpy</p>
         <Link to="/pro/onboard"><Button bsSize="lg" bsStyle="primary">Get Started</Button></Link>
        </div>

        {/*
        {!isLoggedIn && <RegisterForm
         values={{}}
         errors={this.props.errors.register}
         buttonText="Sign Up and Vote"
         onSubmit={(e, values) => this.register(e, values)}
         />}
        {isLoggedIn && <div className="go-to-profile">
         <p>Go to you profile to vote for best rooms</p>
         <Link to={'/p/' + user.profile.username}><Button bsSize="lg" bsStyle="primary">Go To Profile</Button></Link>
        </div>}
        */}
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="ProSplash" helmet="Escape Room Leaderboard">
        <div className="title">
          <div className="icon"><img src="https://escapespy.s3-us-west-2.amazonaws.com/misc/award.svg" /></div>
          <div className="main-title">Escape Room Leaderboard</div>
        </div>
        {this.renderBlurbForm()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    login,
    register,
    fetchUser,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProSplash);



/** WEBPACK FOOTER **
 ** ./src/components/ProSplash.js
 **/